module.exports = __webpack_public_path__ + "static/1-df8c119d8b0b9231cfb662f123db7395.png";